import {Component, EventEmitter, Input, Output} from '@angular/core';
import {KiButtonMapping} from "../../../../model/layout.model";
import {ProgressBarModel, ProgressbarService} from "../../../../service/progressbar.service";
import {AsyncPipe} from "@angular/common";
import {Observable} from "rxjs";
import {MatProgressBarModule} from "@angular/material/progress-bar";
import {EventBusService} from "../../../../service/event-bus.service";
import {EventBusTypes} from "../../../../model/constants";

@Component({
  selector: 'app-ki-button',
  standalone: true,
  imports: [
    AsyncPipe,
    MatProgressBarModule

  ],
  templateUrl: './ki-button.component.html',
  styleUrl: './ki-button.component.css'
})
export class KiButtonComponent {

  @Input() kiButtonMappings: KiButtonMapping[] | undefined= [];

  loading$: Observable<ProgressBarModel>;

  constructor(private progressbarService:ProgressbarService, private eventBusService:EventBusService) {
    this.loading$ = this.progressbarService.loading$;
  }

  doKiMagic($event: MouseEvent) {
    this.eventBusService.emit(EventBusTypes.KI_BUTTON_EVENT.valueOf(), this.kiButtonMappings);
  }

}
